var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category",on:{"click":_vm.onClick}},[_c('div',{staticClass:"category-icon",style:({backgroundImage: 'url(' + _vm.item.icon + ')'})}),_c('div',{staticClass:"category-name"},[_vm._v(_vm._s(_vm.item.name))]),_c('div',{staticClass:"category-points"},[_vm._v("Points: "+_vm._s(_vm.scored)+"/"+_vm._s(_vm.total))])])
}
var staticRenderFns = []

export { render, staticRenderFns }